import { create } from 'zustand';

const useGlobalStore = create((set, get) => ({
  showKPI: localStorage.getItem('showKPI') === 'false' ? false : true,
  // Store  list data
  staffs: [],
  rides: [],
  vendorCategories: [],
  sparePartTags: [],
  workOrderCategories: [],
  vendors: [],
  prevSelectedRow: { id: '', pathname: '' },

  // Action 
  setShowKPI: (showKPI) => {
    localStorage.setItem('showKPI', showKPI);
    set({ showKPI });
  },
  setStaffs: (staffs) => set({ staffs }),
  setRides: (rides) => set({ rides }),
  setVendorCategories: (vendorCategories) => set({ vendorCategories }),
  setWorkOrderCategories: (workOrderCategories) => set({ workOrderCategories }),
  setSparePartTags: (sparePartTags) => set({ sparePartTags }),
  setVendors: (vendors) => set({ vendors }),
  setPrevSelectedRow: (id, pathname) => set({ prevSelectedRow: { id, pathname } }),

  // Action to clear all stored data
  clearStore: () => set({
    showKPI: true,
    staffs: [],
    rides: [],
    vendorCategories: [],
    sparePartTags: [],
    workOrderCategories: [],
    vendors: [],
    prevSelectedRow: { id: '', pathname: '' }
  }),

}));

export default useGlobalStore;
